import { createApp } from "vue";
import App from "./App.vue";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import router from "./router";
import "./registerServiceWorker";
import { createPinia } from "pinia";
import "./firebase";

createApp(App)
  .use(createPinia())
  .use(router)
  .use(Quasar, quasarUserOptions)
  .mount("#app");
